import permissions from '@/enums/permissions';

const BlacklistRouter = [
    {
        path: '/blacklist',
        name: 'blacklist',
        component: () => import('@/views/pages/Blacklist/BlacklistDashboard.vue'),
        meta: {
            permissions: permissions.blacklist,
        },
    },
];

export default BlacklistRouter;
